import {Chip, ChipProps, useTheme} from "@mui/joy";
import {applyTransparency} from "../theme";

const Selectable = (props: ChipProps & { selected?: boolean, onSelect?: () => void }) => {
    const theme = useTheme()
    return <Chip {...props}
                 variant="outlined"
                 onClick={() => props.onSelect?.()}
                 slotProps={{
                     root: {
                         sx: {
                             maxWidth: '100%',
                             paddingX: 2,
                             paddingY: 1,
                         }
                     },
                     action: {
                         sx: {
                             borderColor: props.selected ? "primary.600" : "neutral.500",
                             backgroundColor: props.selected ? applyTransparency(theme.palette.primary["500"], 0.4) : applyTransparency(theme.palette.neutral["300"], 0.05),
                             ":hover": {
                                 borderColor: "primary.600",
                                 backgroundColor: props.selected ? "rgba(255,255,255,0.08)" : applyTransparency(theme.palette.primary["500"], 0.4),
                             }
                         }
                     }
                 }}
                 sx={{
                     borderRadius: 12,
                     padding: 1,
                     paddingX: 2.5,
                     maxWidth: "100%",
                     gap: 1.5,
                     color: props.selected ? "primary.700" : "neutral.300",
                     ...props.sx
                 }}>
        {props.children}
    </Chip>
}

export default Selectable